import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function Reason({ theme, ...props }) {
  return (
    <svg
      aria-labelledby={props.ariaTags.labelledBy}
      aria-hidden={props.ariaTags.hidden}
      className={cx(theme.container, theme[props.svg], props.className)}
      shapeRendering="geometricPrecision"
      tabIndex={props.tabIndex}
      vectorEffect="non-scaling-stroke"
      viewBox="-2 -2 17 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      {props.title ? (
        <title id={props.ariaTags.labelledBy} lang="en">
          {props.title}
        </title>
      ) : null}
      <g
        className={theme.stroke}
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M7.45517049 15.2938518s-.04582693-1.0562719.08130584-1.8072088c.12696851-.7511012.58934413-.6932863.58934413-.6932863h2.31089264c.5891799 0 .7163126-.4968469.7279747-.9590377.0114978-.4621908.0114978-.9705351.0923108-1.6521598.0808131-.68178893.1849503-1.12082094.1849503-1.12082094h.6584952c.4507135 0 .2772611-.56615913.2772611-.56615913l-1.0743869-2.04503838V5.37185972c0-.79643331-.195134-2.23917824-.9799406-3.2591516C9.25375419.82205582 7.63864245 0 5.83135328 0 2.61082081 0 0 2.61070477 0 5.83109411c0 .96068023.25935741 1.85385497.6440408 2.66638448.77478714 1.63688481 1.81238104 3.17719241 1.81238104 4.51580481v2.1780784" />
        <path d="M5.22491028 5.77278645c0 .79741879-.64650461 1.44373042-1.44379459 1.44373042-.79745423 0-1.46761144-.65961563-1.46761144-1.45687017M2.3135371 5.759581l-.00246381-.69065829c0-.97726917.70563612-1.03984725.70563612-1.03984725-.08327689-.3889367.07013655-.76161296.20548203-.96905682.74423586-1.14003786 2.52524436-.99812852 2.52524436-.99812852 2.13711164 0 2.94885599 1.11770028 3.44408246 2.05587868.49522647.9381784-.27364753.97069929-.27364753.97069929h-.82751275c0 .67111291-.67114274.67111291-.67114274.67111291H5.22494313" />
      </g>
    </svg>
  )
}

Reason.propTypes = {
  ariaTags: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  svg: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  className: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
}
